import { useState, useEffect } from 'react';

/**
 * Custom hook for managing image hover and alternating animation
 * @param {number} intervalMs - Interval between image changes in milliseconds (default: 1500)
 * @returns {Object} - { hoveredId, setHoveredId, activeIndex, setActiveIndex }
 */
export const useImageHover = (intervalMs = 1500) => {
  const [hoveredId, setHoveredId] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  // Image alternating animation on hover
  useEffect(() => {
    let interval;
    if (hoveredId) {
      setActiveIndex(0);
      interval = setInterval(() => {
        setActiveIndex((prev) => (prev === 0 ? 1 : 0));
      }, intervalMs);
    } else {
      setActiveIndex(0);
    }
    return () => clearInterval(interval);
  }, [hoveredId, intervalMs]);

  return {
    hoveredId,
    setHoveredId,
    activeIndex,
    setActiveIndex
  };
};

export default useImageHover;
